var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7809_110930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.345 13.3337L13.7967 4.88206L12.6183 3.70373L4.16667 12.1554V13.3337H5.345ZM6.03583 15.0004H2.5V11.4646L12.0292 1.9354C12.1854 1.77917 12.3974 1.69141 12.6183 1.69141C12.8393 1.69141 13.0512 1.77917 13.2075 1.9354L15.565 4.2929C15.7212 4.44917 15.809 4.66109 15.809 4.88206C15.809 5.10303 15.7212 5.31496 15.565 5.47123L6.03583 15.0004ZM2.5 16.6671H17.5V18.3337H2.5V16.6671Z",
    fill: "#505666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7809_110930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.10c7ec53.svg";
export { ForwardRef as ReactComponent };